export const bowtieTranslations = {
  connected_cases: 3021,
  done: 7338,
  bowtie_connect_cases: 8208,
  select_connection_type: 8209,
  inspection_evaluation: 8207,
  fetching_evaluation: 4501,
  no_evaluation_data: 5930,
  filters_header: 8640,
  filters_help_text: 8641,
  text_page_of: 8454,
  placeholderSearch: 7587,
  textAddExisting: 3386,
  textConnect: 8111,
  textDisconnect: 8117,
  textNoConnectionToItself: 7771,
  titleSearch: 7588,
  textWarningModalTitle: 8325,
  textWarningModalDescription: 8326,
  textWarningModalContinue: 8327,
  textWarningModalCancel: 3273,
  textDisconnectWarningModalTitle: 9724,
  textDisconnectWarningModalDescription: 9725,
  textDisconnectWarningModalContinue: 9724,
  textDisconnectWarningModalCancel: 3273
};

export type BowtieTranslation = {
  readonly [T in keyof typeof bowtieTranslations]: string
};

export enum BussinesType {
  notSelected = 0,
  generalCategory = 1
}

export const showOtherConnectionsAttribute = 'bowtie.option.draftModeShowOtherConnections';
export const bowtieFavouriteIdCache: string = 'bowtie.connectedCases.bowtieFavouriteId';
